export const getClassName = (schoolClass: { name: string; nickname?: string | null }): string => {
  return schoolClass.nickname ? `${schoolClass.name} "${schoolClass.nickname}"` : schoolClass.name;
};
